export default {
  channel: 'Canal',
  spend: 'Investimento',
  share: 'Participação',
  copy: 'Copiar para a área de transferência',
  copied: 'Copiado!',
  copyFailed: 'Não foi possível copiar',
  dataView: 'Visualização de Dados',
  close: 'Fechar',
  refresh: 'Atualizar',
  saveAsImage: 'Salvar como Imagem'
}
